import once from 'lodash/once'

import { getGoogleTagManagerId } from '../services/Env'

declare global {
  interface Window {
    dataLayer: Array<{ [key: string]: any }>
    gtm: (params: { [key: string]: any }) => void
  }
}

const GoogleTagManager = {
  initialize: once(() => {
    const id = getGoogleTagManagerId()
    if (!id) {
      return
    }

    // @ts-ignore
    // prettier-ignore
    // eslint-disable-next-line
    {(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',id);}
  }),
}

export default GoogleTagManager
